export default "__VITE_ASSET__DuVrgh_y__"